import * as React from 'react';
import Layout from './layout/layout';
import { Grid, IconButton, Button, Toolbar, Typography, Divider, Autocomplete, TextField } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useForm } from 'react-hook-form';
import { FormContainer, TextFieldElement, SelectElement } from 'react-hook-form-mui';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

import axios from '../AxiosInstance';
import moment from '../config/moment.config';

import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import CommissionHistory from '../components/commissionHistory';
import useNotification from '../components/notification';
import { ListContext } from '../context/GeneralListContext';



const schema = yup.object().shape({
  // firstname: yup.string().required(),
  portno: yup.string().required(),
  portname: yup.string().required(),
  broker: yup.number().required(),
  porttype: yup.string().required(),
});

export default function EditPort() {
  const { id } = useParams();
  const mode = id === 'add' ? 'ADD' : 'EDIT';
  const history = useNavigate();
  const { sendNotification } = useNotification();
  const { search } = useLocation();
  const { productList, brokerList, portTypeList } = React.useContext(ListContext);
  const [selectedMaster, setSelectedMaster] = React.useState(null);
  const [portData, setPortData] = React.useState(null);
  const [masters, setMasters] = React.useState([]);

  const masterUuid = new URLSearchParams(search, [search]).get('master_id');

  const formContext = useForm({
    resolver: yupResolver(schema),
  });

  // fetch data from API function
  async function fetch() {
    axios.get(`/ports/${id}`).then((response) => {
      const portDetail = {
        portId: response.data.portfolioId,
        portno: response.data.portfolioNumber,
        portname: response.data.name,
        broker: response.data.brokerId || '',
        porttype: response.data.portfolioType || '',
        product: response.data.productId || '',
        initial_balance: response.data.initialBalance,
        created_date: moment(response.data.created_date).format('lll'),
        updated_date: moment(response.data.updated_date).format('lll'),
        master: response.data.master
          ? {
              masterId: response.data.master.masterId,
              masterUuid: response.data.master.masterUuid,
              masterName: `${response.data.master.firstname} ${response.data.master.lastname}`,
            }
          : null,
        commissionHistory: response.data.commission_report_lines,
      };
      console.log(response.data, 'port detail');

      setPortData(portDetail);
    });
  }
  React.useEffect(() => {
    axios.get(`/masters?mode=masteronly`).then((response) => {
      for (let master of response.data) {
        master.label = `${master.firstname} ${master.lastname}`;
      }
      // console.log(response.data);
      setMasters(response.data);
      // console.log('set masters');
      if (masterUuid) {
        const selMaster = response.data.find((m) => {
          return (m.masterUuid = masterUuid);
        });
        setSelectedMaster(selMaster);
      }
      if (mode !== 'ADD') {
        fetch();
      }
    });

    // console.log(masterUuid);
  }, []);

  React.useEffect(() => {
    formContext.reset(portData);
    // console.log(masters, 'master list');
    const selMaster = masters.find((m) => {
      return m.masterUuid === portData.master?.masterUuid;
    });
    // console.log(selMaster, 'select master');
    setSelectedMaster(selMaster);
  }, [portData]);

  const handleSubmit = async (data) => {
    // console.log(data);
    const editport = {
      portNo: data.portno,
      portName: data.portname,
      brokerId: data.broker,
      portType: data.porttype,
      productId: data.product,
      masterId: selectedMaster?.masterId,
      initialBalance: data.initial_balance,
    };
    if (mode === 'ADD') {
      // console.log('hello');
      if (!selectedMaster) {
        sendNotification({ msg: 'ไม่มี master Id', variant: 'error' });
      } else {
        // console.log(selectedMaster);
        // console.log(data);
        axios
          .post(`/ports/add/master/${selectedMaster.masterUuid}`, editport)
          .then((res) => {
            sendNotification({ msg: `Add Port ${data.portno} Success`, variant: 'success' });
            history.goBack();
          })
          .catch((err) => {
            sendNotification({ msg: "can't save pls open console", variant: 'error' });
            console.log(err);
          });
      }
    } else {
      // MODE : EDIT

      axios
        .put(`/ports/${id}`, editport)
        .then((res) => {
          sendNotification({ msg: `Update Port ${data.portno} Success`, variant: 'success' });
          history.goBack();
        })
        .catch((err) => {
          sendNotification({ msg: "can't save pls open console", variant: 'error' });
          console.log(err);
        });
    }
  };

  return (
    <Layout>
      <Grid container spacing={3}>
        <Grid item md={8}>
          <FormContainer formContext={formContext} onSuccess={handleSubmit}>
            <Toolbar sx={{ width: '100%', marginBottom: 3 }}>
              <IconButton size='small' onClick={() => history.goBack()} sx={{ marginRight: 2 }}>
                <ArrowBackIcon />
              </IconButton>
              <Typography variant='h6' noWrap component='div' sx={{ flex: 1 }}>
                {mode === 'ADD' ? 'Add Port' : 'Edit Port'}
              </Typography>
              <Button size='small' type='submit'>
                Save
              </Button>
            </Toolbar>

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Autocomplete
                  // options={}
                  fullWidth
                  options={masters}
                  onChange={(event, newValue) => {
                    // console.log(newValue);
                    setSelectedMaster(newValue);
                  }}
                  value={selectedMaster}
                  // isOptionEqualToValue={(option, value) => option.id === value.id}
                  getOptionLabel={(option) => option.label}
                  disableClearable
                  renderInput={(params) => <TextField {...params} label='Master' size='small' />}
                />
              </Grid>
            </Grid>
            <Divider sx={{ marginY: 3 }} />

            <Grid container spacing={2}>
              <Grid item sm={6} xs={12}>
                <TextFieldElement name='portno' label='Port No. *' fullWidth size='small' />
              </Grid>
              <Grid item sm={6} xs={12}>
                <TextFieldElement name='portname' label='Port Name *' fullWidth size='small' />
              </Grid>
              <Grid item sm={6} xs={12}>
                <SelectElement name='broker' label='Broker *' fullWidth size='small' options={brokerList} />
              </Grid>
              <Grid item sm={6} xs={12}>
                <TextFieldElement name='initial_balance' label='Initial Balance' fullWidth size='small' />
              </Grid>
              <Grid item sm={6} xs={12}>
                <SelectElement name='porttype' label='Port type' fullWidth size='small' options={portTypeList} />
              </Grid>
              <Grid item sm={6} xs={12}>
                <SelectElement name='product' label='Product' fullWidth size='small' options={productList} />
              </Grid>
            </Grid>
          </FormContainer>
        </Grid>
        {mode === 'ADD' ? null : (
          <Grid item md={4} sm={12} xs={12}>
            <CommissionHistory data={portData?.commissionHistory} />
          </Grid>
        )}
      </Grid>
    </Layout>
  );
}
